/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import {View} from 'react-native';

import RankProgressDetail from '/component/partial/RankProgressCard/Detail';
import RankProgressBar from '/component/partial/RankProgressCard/ProgressBar';
import RankProgressSummary from '/component/partial/RankProgressCard/Summary';

import {styles} from './RankProgression.style';
interface RankProgressionProps {
  coachId: number | null;
  getTheme: () => void;
  onShowInfoPopover: () => void;
}

export const RankProgression: React.FC<RankProgressionProps> = ({coachId}) => (
  <View style={styles.base}>
    <View style={styles.summary}>
      <RankProgressSummary coachId={coachId} isUser={false} />
      <RankProgressBar coachId={coachId} />
    </View>
    <RankProgressDetail coachId={coachId} />
  </View>
);

export default RankProgression;
